<template>
    <draggable
        :list="obtenerListaDeContenidosOriginal"
        :disabled="!habilitado"
        :scroll-sensitivity="50"
        :force-fallback="false"
        id="listaOrdenable_arrastrable"
        class="listaOrdenable"
        handle=".contenidoLista-titulo-texto"
        dragClass="listaOrdenable-arrastra"
        chosenClass="listaOrdenable-selecciona" 
        ghost-class="listaOrdenable-fantasma"
        @start="arrastrando = true"
        @end="finalizoArrastre"
    >
        <div v-bind:class="[arrastrando?'listaOrdenable-arrastra':'listaOrdenable-hover','contenidoLista']" v-for="elementoContenidos in obtenerListaDeContenidosOriginal" :key="elementoContenidos.id" @mouseover="elementoContenidos.hover = true" @mouseleave="elementoContenidos.hover = false">
            <div v-bind:class="[elementoContenidos.hover ? 'contenidoLista-hover contenidoLista-scroll' : 'contenidoLista-no-hover contenidoLista-scroll']">
                <div class="contenidoLista-titulo-texto">
                    <h6 v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario != formularioComunicado"><b>#Folio: {{elementoContenidos.contenido.ContenidoDeLaPaginaWebId}}</b> <br>[ <i class="far fa-calendar-alt"></i> Fecha de publicación: {{ obtenerFechaConFormato(elementoContenidos.contenido.FechaDePublicacion) }}] <br> {{ elementoContenidos.contenido.TextoDelContenido != null ? reemplazaCaracteresEspeciales(elementoContenidos.contenido.TextoDelContenido, elementoContenidos.contenido.SeccionDeLaPaginaWebId) : elementoContenidos.contenido.TextoDelVinculo}}</h6>
                    <h6 v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado && !elementoContenidos.conIconoUrgenteVisible"><b>#Folio: {{elementoContenidos.contenido.ContenidoDeLaPaginaWebId}}</b> <br>[ <i class="far fa-calendar-alt"></i> Fecha de publicación: {{ obtenerFechaConFormato(elementoContenidos.contenido.FechaDePublicacion) }}] <br> {{ elementoContenidos.contenido.Titulo }}</h6>
                    <h6 v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado && elementoContenidos.conIconoUrgenteVisible"><b>#Folio: {{elementoContenidos.contenido.ContenidoDeLaPaginaWebId}}</b> <br>[ <i class="far fa-calendar-alt"></i> Periodo de publicación: {{ obtenerFechaConFormato(elementoContenidos.contenido.FechaDePublicacion) }} al {{ obtenerFechaConFormato(elementoContenidos.contenido.FechaDePublicacionFinal) }}] <br> {{ elementoContenidos.contenido.Titulo }}</h6>
                </div>
                <div v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado || elementoContenidos.contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0" class="contenidoLista-titulo-icono" @click="elementoContenidos.mostrarDescripcion = !elementoContenidos.mostrarDescripcion">
                    <i v-bind:class="[elementoContenidos.mostrarDescripcion ? 'fa-caret-up' : 'fa-caret-down','fas fa-2x' ]"></i>
                </div>
                <div v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado || obtenerPaginaWebId == 1 || obtenerPaginaWebId == 29" class="contenidoLista-iconos-extras">
                    <i v-if="elementoContenidos.conIconoMostrarEnInicio || elementoContenidos.contenido.EsPin" class="fas fa-eye fa-lg"  v-tooltip:top="'Mostrar en Inicio'"></i>
                    <i v-if="elementoContenidos.conIconoUrgenteVisible" class="fas fa-exclamation fa-lg" v-tooltip:top="'Noticia Urgente'"></i>
                    <i v-if="elementoContenidos.contenido.EsPin" class="fas fa-thumbtack fa-lg" v-tooltip:top="'Pin'"></i>
                    <i v-if="elementoContenidos.contenido.EsDisposicionEspecial" class="fas fa-layer-group fa-lg" v-tooltip:top="'Disposición Especial'"></i>
                </div>
            </div>
            <div v-if="elementoContenidos.mostrarDescripcion" v-bind:class="[elementoContenidos.hover ? 'contenidoLista-hover' : 'contenidoLista-no-hover']" >
                <transition name="slide-fade">
                    <p v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado">{{ reemplazaCaracteresEspeciales(elementoContenidos.contenido.TextoDelContenido) }}</p>
                </transition>
                <transition name="slide-fade">
                    <table v-if="elementoContenidos.contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0" class="table table-dark tabla-listado-archivos" style="width: 100%; heigth: 100%">
                        <thead>
                            <tr>
                            <th style="width: 40%" scope="col">Nombre del archivo</th>
                            <th v-if="elementoContenidos.contenido.ArchivosDeContenidoDeLaPaginaWeb.length != 1 && elementoContenidos.contenido.TextoDelContenido != null" style="width: 30%" scope="col">Texto del vínculo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(archivo,index) in elementoContenidos.contenido.ArchivosDeContenidoDeLaPaginaWeb" :key="'Archivo' + index">
                                <td style="width: 40%">{{archivo.NombreBase}}</td>
                                <td v-if="elementoContenidos.contenido.ArchivosDeContenidoDeLaPaginaWeb.length != 1 && elementoContenidos.contenido.TextoDelContenido != null" style="width: 30%">{{archivo.TextoDelVinculo}}</td>
                            </tr>
                        </tbody>
                    </table>
                </transition>
                <transition name="slide-fade">
                    <table v-if="elementoContenidos.contenido.Vinculo!=null" class="table table-dark tabla-listado-archivos" style="width: 100%; heigth: 100%">
                        <tbody>
                            <tr>
                                <td style="width: 40%">{{elementoContenidos.contenido.Vinculo}}</td>
                                <td v-if="elementoContenidos.contenido.TextoDelContenido != null && obtenerCamposRequeridosEnFormulario.tipoDeFormulario == formularioComunicado" style="width: 30%">{{elementoContenidos.contenido.TextoDelVinculo}}</td>
                            </tr>
                        </tbody>
                    </table>
                </transition>
            </div>
        </div>
    </draggable>   
</template>

<script>
    import enumeraciones from '@/../static/js/enumeraciones'
    import api from '@/../static/js/api'
    import comun from '@/../static/js/comun'
    import axios from 'axios'
    import draggable from "vuedraggable";
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

 
    export default {
        directives: {
            tooltipF
        },
        components: {
            draggable
        },
        props: {
            esParaEdicion: {
                type: Boolean,
                default: false
            },
            listaDeContenidos: {
                type: Array,
                default: () => []
            },
            camposRequeridosEnFormulario: {
                type: Object,
                default: () => ({})
            },
            paginaWebId: {
                type: Number,
                default: -1
            },
            seccionId: {
                type: Number,
                default: -1
            },
        },
        data() {
            return {
                habilitado: true,
                editado: false,
                arrastrando: false,
                listadoElementosOrdenados:[],
                formularioComunicado: 'comunicado',
            };
        },
        computed: {
            obtenerInformacionDePintado() {
                return this.arrastrando ? "under drag" : "";
            },
            obtenerListaDeContenidosOriginal() {
                return (this.esParaEdicion) ? this.listaDeContenidos : this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
            },
            obtenerPaginaWebId() {
                return (this.esParaEdicion) ? this.paginaWebId : this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
            },
            obtenerCamposRequeridosEnFormulario() {
                return (this.esParaEdicion) ? this.camposRequeridosEnFormulario : this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario;
            }
        },
        methods: {
            obtenerFechaConFormato: function(fecha){
                //import func from '../../../../../vue-temp/vue-editor-bridge'
                moment.locale("es");
                return moment(fecha).format('DD MMMM YYYY');
            },
            /**
             * Método encargado de reemplazar el caracter especial "¶" de consejeros, y/ o agregar más en caso de requerirse.  
             * @param {String} textoDelContenido [evento emitido por el draggable]
             */
            reemplazaCaracteresEspeciales: function(textoDelContenido){
                let seccionId = (this.esParaEdicion) ? this.seccionId : this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId;
                return seccionId == 3? textoDelContenido.replace("¶", " - Designado por: ") : textoDelContenido;
            },
            /**
             * Metodo encargado de restablecer el orden de los contenidos en base la interaccion del usuario
             * con los items del draggable.  
             * @param {Object} e [evento emitido por el draggable]
             */
            finalizoArrastre: function(e) {
                this.arrastrando = false;
                
                let listado = this.obtenerListaDeContenidosOriginal;
                this.editado = false
                for(var i=0;i<listado.length;i++){
                    if(listado[i].contenido.OrdenDelContenido != i+1)
                        this.editado = true;
                    if(i<3 && this.obtenerCamposRequeridosEnFormulario!= undefined && this.obtenerCamposRequeridosEnFormulario.tipoDeFormulario == this.formularioComunicado)
                        listado[i].conIconoMostrarEnInicio = true;
                    else if(i==0 && (this.obtenerPaginaWebId == 1 || this.obtenerPaginaWebId == 29))
                        listado[i].conIconoMostrarEnInicio = true;
                    else 
                        listado[i].conIconoMostrarEnInicio = false;
                }
                if(!this.esParaEdicion) {
                    this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",this.editado);
                }
            }
        }
    }
</script>

<style scoped>
    .contenidoLista
    {
        position: relative;
        background: none;
        border: none;
        padding: 1%;
        width: 100%;
    }
    .contenidoLista-no-hover
    {
        background-color: #323335;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        padding: 0.5em;
        white-space: pre-line;
    }
    .contenidoLista-hover
    {
        background-color: #FFFFFF;
        border: 1px solid #000000;
        color: black;
        padding: 0.5em;
        white-space: pre-line;
    }
    .contenidoLista-titulo-texto
    {
        display: inline-block;
        cursor: move;
        min-width: 70%;
        max-width: 90%;
        user-select: none;
        white-space: pre-line;
    }

    .contenidoLista-scroll {
        overflow-y: auto;
        max-height: 80px;
        
    }
  
    .contenidoLista-titulo-icono
    {
        right: 0px;
        float: right;
        height: 100%;
        padding-left: 5px;
        cursor: pointer;
        margin-right: 1em;
    }
    .contenidoLista-iconos-extras
    {
        right: 0px;
        float: right;
        height: 100%;
        padding: 3px;
        margin-left: 0.4em;
        margin-right: 1em;
    }

    .contenidoLista-iconos-extras i
    {
        padding: 0.3em;
    }

    .listaOrdenable_div
    {
        background-color: #57585B;
        padding: 0.5%;
    }
    #listaOrdenable_arrastrable
    {
        background: #57585B ;
        max-height: 100%;
        padding: 5px;
    }
    .listaOrdenable-selecciona{
        opacity: 0.4;
    }
    .listaOrdenable-fantasma{
        opacity: 1;
        background:cadetblue;/*#323335;*/
    }
    .listaOrdenable-arrastra {
        opacity: 0.4;
    }
    h6{
        white-space: pre-line;
    }
    .tabla-listado-archivos{
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
    }

    .tabla-listado-archivos th {
        top: 0;
        background: #474749;
        border: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/AltaDeContenido/ListaOrdenableDeContenido.vue